// extracted by mini-css-extract-plugin
export default {"LinkCard":"LinkCard_LinkCard__KRQQr"};